import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetTreatDailySummariesQuery,
  GetTreatDailySummariesQueryVariables,
} from "./TreatDailySummaries.generated";

const TREAT_DAILY_SUMMARIES_QUERY: TypedDocumentNode<
  GetTreatDailySummariesQuery,
  GetTreatDailySummariesQueryVariables
> = gql`
  query GetTreatDailySummaries($days: Int = 30, $timezone: String) {
    treatDailySummaries(days: $days, timezone: $timezone) {
      date
      netChange
      treatsCredited
      treatsUsed
    }
  }
`;

export default TREAT_DAILY_SUMMARIES_QUERY;
